import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Hero from '../views/sections/Hero';
import Popular from '../views/sections/Popular';
import NextTrip from '../views/sections/NextTrip';
import Deals from '../views/sections/Deals';
import Specials from '../views/sections/Specials';
import Packages from '../views/sections/Packages';
import Gallery from '../views/sections/Gallery';
import Reviews from '../views/Reviews';
import CTA from '../views/sections/CTA';
import Services from '../views/Services';
import About from './About';
import Contact from './Contact';

export default function Home(){
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);
  const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22,1,0.36,1] } }
  };
  return (
    <>
      <Hero />
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Popular />
      </motion.section> */}
      <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Services />
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <About isHomePage={true} />
      </motion.section>
      <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Contact />
      </motion.section>
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <NextTrip />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Deals />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Specials />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Packages />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Gallery />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <Reviews />
      </motion.section> */}
      {/* <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
        <CTA />
      </motion.section> */}
    </>
  );
}
